// Thin host wrapper — LADDER-Intl (R1–R5). Per-rung tier gate at the
// route/UI layer (the shipped pattern, same as Focus/Value): R1–R3 =
// Sika Pro+, R4–R5 = Pro+ (spec A-17 "Pro tier and above"). Founder
// (black) sees all. Upgrade CTA NAVIGATES only — never charges.
import { useNavigate } from "react-router-dom";
import { useUserTier } from "../../auth/useUserTier.ts";
import { tierMeets } from "../../auth/tier-gates.ts";
import { useIntlAccaLadder } from "../../intl-acca/useIntlAccaLadder.ts";
import { LadderIntlPage } from "./LadderIntlPage.tsx";

export function IntlAccaLadderRoute(): JSX.Element {
  const navigate = useNavigate();
  const { tierCode } = useUserTier();
  const vm = useIntlAccaLadder();

  const sikaPro = tierMeets(tierCode, "sika_pro");
  const proPlus = tierMeets(tierCode, "phantom_pro");
  const unlocked = {
    R1: sikaPro, R2: sikaPro, R3: sikaPro,
    R4: proPlus, R5: proPlus,
  };

  return (
    <LadderIntlPage
      loading={vm.loading}
      error={vm.error}
      tournament={vm.tournament}
      rungs={vm.rungs}
      matchLabels={vm.matchLabels}
      unlocked={unlocked}
      onUpgrade={() => navigate("/intl-acca/pass")}
    />
  );
}
